import { FormHelperText } from "@mui/material";
import React from "react";
import {
  ERROR_HELPERTEXT_STYLES,
  PRIMARY_COLOR,
  WARNING_COLOR,
} from "../utils";
import { ConfigProvider, DatePicker } from "antd";

const DateField = ({
  label,
  value,
  disabled = false,
  name,
  error_state,
  error_text,
  placeholder,
  helperText,
  handleChange,
  required = false,
  size,
}) => {
  return (
    <div
      className={`textfield ${error_state && "error_textfield"}`}
      style={{
        alignItems: helperText && "flex-start",
      }}
    >
      <label
        htmlFor={name}
        style={{
          marginBottom: (helperText || error_state) && "10px",
          fontSize: size === "middle" ? ".8rem" : "",
        }}
      >
        {label}
        {required ? <span>*</span> : ""}
      </label>
      <div>
        <ConfigProvider
          theme={{
            components: {
              DatePicker: {
                activeBorderColor: PRIMARY_COLOR,
                cellHoverWithRangeBg: "#fff",
                hoverBorderColor: PRIMARY_COLOR,
                cellRangeBorderColor: "#fff",
                cellActiveWithRangeBg: "#fff",
                activeShadow: "0 0 0 0",
              },
            },
            token: {
              colorPrimary: PRIMARY_COLOR,
              colorErrorOutline: "none",
              colorError: WARNING_COLOR,
              colorErrorBorderHover: "none",
              fontSize: 12,
            },
          }}
        >
          <DatePicker
            id={name}
            name={name}
            size={size ? size : "large"}
            className="input"
            disabled={disabled}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            style={{ width: "100%" }}
            status={error_state && "error"}
            format="DD-MMM-YYYY"
          />
        </ConfigProvider>
        {helperText ? (
          <FormHelperText
            sx={{
              fontStyle: "italic",
              fontSize: "0.75rem",
              color: "#a0aec0",
              margin: "8px 0",
              lineHeight: "1rem",
              letterSpacing: "0.7px",
              fontFamily: "Montserrat",
            }}
          >
            {helperText}
          </FormHelperText>
        ) : (
          ""
        )}
        {error_state && (
          <FormHelperText sx={ERROR_HELPERTEXT_STYLES}>
            {error_text}
          </FormHelperText>
        )}
      </div>
    </div>
  );
};

export default DateField;
